import { combineReducers } from 'redux';
import { issues } from './issues';

//add reducers- currently only one - issues
export default combineReducers({
  issues,
});
